export const createUserInitialValues = {
  firstName: '',
  surname: '',
  email: '',
  password: '',
}
